/*
 Copyright 2025 Google LLC

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

export * from "./react-renderer/index.js";
export { DEFAULT_SURFACE_ID, ROOT_COMPONENT_ID } from "./a2ui-types.js";
export type { Theme, A2UIClientEventMessage } from "./a2ui-types.js";

// Backward compat: viewerTheme (v0.9 themes handled internally)
export const viewerTheme: Record<string, unknown> = {};
